import { render, staticRenderFns } from "./ratingPopup.vue?vue&type=template&id=22b3cdb3&scoped=true"
import script from "./ratingPopup.vue?vue&type=script&lang=js"
export * from "./ratingPopup.vue?vue&type=script&lang=js"
import style0 from "./ratingPopup.vue?vue&type=style&index=0&id=22b3cdb3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b3cdb3",
  null
  
)

export default component.exports